import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';
import { observer } from 'mobx-react';
import has from 'lodash/get';

import { ReviewToolbar as ReviewToolbarView } from '@shared/ReviewToolbar';
import NonpremiumSchoolModal from '../main-app/components/window/NonpremiumSchool';
import ReportWindow from '../main-app/components/window/Report';
import ShareLinkWindow from '../main-app/components/window/ShareLink';

import { addBodyScroll, removeBodyScroll } from '../main-app/utils/documentHelper';

import stores from '../main-app/stores';

class ReviewToolbarClassComponent extends Component {
  constructor(props) {
    super(props);
    const { isSubscribed, isOwner } = props;
    this.state = {
      isSubscribed: JSON.parse(isSubscribed),
      isOwner: JSON.parse(isOwner),
      showAnswerForm: false,
      answerText: '',
    };
  }

  // eslint-disable-next-line react/sort-comp
  closeNonpremiumModal = (root) => {
    root.unmount();
    addBodyScroll();
  };

  jumpToSubscribePage = () => {
    const { schoolId } = this.props;
    document.location.href = `/pro/schools/${schoolId}/subscribe`;
  };

  showNonpremiumModal = () => {
    const node = document.getElementById('vv-rating-box__nonpremium-window');
    const { nonPremiumSchoolTitle, nonPremiumSchoolText } = this.props;
    removeBodyScroll();

    const root = createRoot(node);
    root.render(
      <NonpremiumSchoolModal
        title={nonPremiumSchoolTitle}
        texts={nonPremiumSchoolText}
        onDismiss={() => this.closeNonpremiumModal(root)}
        onConfirm={this.jumpToSubscribePage}
      />,
    );
  };

  closeShareLinkWindow = (root) => {
    root.unmount();
  };

  showShareLinkWindow = () => {
    const { reviewId, isSchool, isAvisSolution } = this.props;
    const node = document.getElementsByClassName(
      `vv-rating-box__share-window-${reviewId}`,
    )[0];

    const root = createRoot(node);
    root.render(
      <ShareLinkWindow
        reviewId={reviewId}
        isSchool={isSchool}
        onClose={() => this.closeShareLinkWindow(root)}
        isAvisSolution={isAvisSolution}
      />,
    );
  };

  onAnswerClick = () => {
    const { isSubscribed } = this.state;

    if (isSubscribed) {
      this.setState({
        showAnswerForm: true,
      });
    } else {
      this.showNonpremiumModal();
    }
  };

  hideAnswerForm = (answer) => {
    this.setState({
      showAnswerForm: false,
      answerText: answer,
    });
  };

  closeReportWindow = (root) => {
    root.unmount();
    stores.reviewsStore.reportResult = null;
    addBodyScroll();
  };

  showReportWindow = () => {
    const { reviewId, isSchool, isAvisSolution } = this.props;
    const node = document.getElementById('vv-rating-box__report-window');
    removeBodyScroll();

    const root = createRoot(node);
    root.render(
      <ReportWindow reviewId={reviewId} onClose={() => this.closeReportWindow(root)} isSchool={isSchool} isAvisSolution={isAvisSolution} />,
    );
  };

  sendAnswer = () => {
    const { reviewId, isSchool } = this.props;
    const { answerText } = this.state;
    const callbackObj = {
      setErrors: () => {},
    };

    stores.reviewsStore.answer(
      {
        id: reviewId,
        answer: answerText,
      },
      callbackObj,
      isSchool,
    );
    this.setState({
      showAnswerForm: false,
    });
  };

  componentDidMount() {
    this.setAnswer();
  }

  render() {
    const {
      reviewId, hasAnswer, isAvisSolution, isSchool,
    } = this.props;
    const { answers, isSending } = stores.reviewsStore;
    const { showAnswerForm, isOwner, answerText } = this.state;

    this.setAnswer = () => {
      this.setState({ answerText: answers[reviewId] });
    };

    return (
      <>
        <ReviewToolbarView
          reviewId={reviewId}
          answer={answers[reviewId]}
          isModifyView={!!answers[reviewId]}
          onAnswerClick={this.onAnswerClick}
          hasAnswerForm={showAnswerForm}
          hasAnswerButton={isOwner && !has(answers, reviewId) && !JSON.parse(hasAnswer) && !showAnswerForm}
          hasUpdateButton={isOwner && !showAnswerForm}
          onAnswerChange={(e) => this.setState({ answerText: e.target.value })}
          answerValue={answerText}
          onAnswerSubmit={this.sendAnswer}
          onAnswerCancel={() => this.hideAnswerForm(answers[reviewId])}
          isAnswerSending={isSending}
          showReportWindow={this.showReportWindow}
          showShareLinkWindow={this.showShareLinkWindow}
          isAvisSolution={isAvisSolution}
          isSchool={isSchool}
        />
      </>
    );
  }
}

ReviewToolbarClassComponent.propTypes = {
  reviewId: PropTypes.string,
  isSubscribed: PropTypes.bool,
  isOwner: PropTypes.bool,
  nonPremiumSchoolTitle: PropTypes.string,
  nonPremiumSchoolText: PropTypes.string,
  hasAnswer: PropTypes.string,
  isSchool: PropTypes.bool,
  schoolId: PropTypes.string,
  isAvisSolution: PropTypes.bool,
};

ReviewToolbarClassComponent.defaultProps = {
  reviewId: null,
  isSubscribed: false,
  isOwner: false,
  nonPremiumSchoolTitle: '',
  nonPremiumSchoolText: '',
  hasAnswer: '',
  isSchool: true,
  schoolId: '',
  isAvisSolution: false,
};

const ReviewToolbar = observer(ReviewToolbarClassComponent);

document.addEventListener('DOMContentLoaded', () => {
  const reviews = document.querySelectorAll('.vv-rating-box__bottom-toolbar');

  reviews.forEach((review) => {
    const answer = review.getAttribute('data-answer');
    const id = review.getAttribute('data-review-id');

    if (answer && id) {
      stores.reviewsStore.setAnswer(id, answer);
    }
    const root = createRoot(review);
    root.render(
      <ReviewToolbar
        reviewId={id}
        hasAnswer={review.getAttribute('data-has-answer')}
        isSubscribed={review.getAttribute('data-is-subscribed')}
        isOwner={review.getAttribute('data-isOwner')}
        nonPremiumSchoolTitle={review.getAttribute('data-nonpremium-title')}
        nonPremiumSchoolText={review.getAttribute('data-nonpremium-text')}
        isSchool={review.hasAttribute('data-is-school')}
        schoolId={review.getAttribute('data-school-id')}
        isAvisSolution={review.getAttribute('data-is-avis-solution') !== '' ? JSON.parse(review.getAttribute('data-is-avis-solution')) : false}
      />,
    );
  });
});

export { ReviewToolbarClassComponent };
